export const GLOBAL_FORM_STYLES_CLASS = 'global-form-styles';
